



























import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';
import SpeakerIcon from './SpeakerIcon.vue';

const yearMonthFormat = 'YYYY[年]MM[月]';

@Component({
    components: {
        SpeakerIcon,
    },
    filters: {
        toYearMonthString(date: Date): string | null {
            if (!date) {
                return null;
            }
            return moment(date).locale('ja').format(yearMonthFormat);
        },
    },
})
export default class UsageSummaryComponent extends Vue {
    @Prop() public preparationDate?: Date;
    @Prop() public takingTime?: string;
    @Prop() public totalAmount?: number;

    private expandable = false;
    private expanded = false;

    public mounted() {
        // コンテンツが2行以上になっているかはわからないので、
        // 親要素と自分の高さを比べて親より大きくなっていたら二行以上と判定。
        // 二行以上であればヘッダーを開閉できるような仕様
        this.expandable = this.isTakingTimeOverflow();
    }

    public updated() {
        if (!this.expanded) {
          this.expandable = this.isTakingTimeOverflow();
        }
    }

    get expandIconText() {
        return this.expanded ? 'expand_less' : 'expand_more';
    }

    /**
     * 時点名の表示高さが親要素を超えているかを判定
     */
    public isTakingTimeOverflow() {
        const wrapper = this.$refs.takingTimeWrapper as Element;
        const content = this.$refs.takingTimeContent as Element;
        if (!wrapper || !content) { return false; }

        return wrapper.clientHeight !== content.clientHeight;
    }

    /**
     * ヘッダーの開閉を実行
     */
    public expandHeader() {
        this.expanded = !this.expanded;
    }
}
